/*
 Theme Name: My Bleem
 Description: Util - Media query validation
 Author: Daniel Santos
 Author URL:  https://github.com/DanielGradi
 Tags: My Bleem
*/

/**
 * Validate screen size
 * @param {string} query - Queries how css, ex: '(min-with: 992px)'
 * @param {function} cb - Callback to run if is math with screen size
 * @author Daniel Santos <daniel.santos@gradiweb.com>
 */
function mediaQuery(query, cb) {
  const mql = window.matchMedia(query);

  if (mql.matches) {
    cb();
  }
}

export { mediaQuery };
